import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

interface ICircularArrowIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const CircularArrowIcon = ({
  width = styleConfigs.dimensions.width30,
  height = styleConfigs.dimensions.height30,
  color = COLORS.emeraldFern,
  ...props
}: ICircularArrowIconProps): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.0626 7.93749C20.0251 5.89999 17.1376 4.72499 13.9626 5.04999C9.37509 5.51249 5.60009 9.23749 5.08759 13.825C4.40009 19.8875 9.08759 25 15.0001 25C18.9876 25 22.4126 22.6625 24.0126 19.3C24.4126 18.4625 23.8126 17.5 22.8876 17.5C22.4251 17.5 21.9876 17.75 21.7876 18.1625C20.3751 21.2 16.9876 23.125 13.2876 22.3C10.5126 21.6875 8.27509 19.425 7.68759 16.65C6.63759 11.8 10.3251 7.49999 15.0001 7.49999C17.0751 7.49999 18.9251 8.36249 20.2751 9.72499L18.3876 11.6125C17.6001 12.4 18.1501 13.75 19.2626 13.75H23.7501C24.4376 13.75 25.0001 13.1875 25.0001 12.5V8.01249C25.0001 6.89999 23.6501 6.33749 22.8626 7.12499L22.0626 7.93749Z"
      fill={color}
    />
  </svg>
);

export default CircularArrowIcon;
